import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { GlobalService } from '../global.service';
import { ModalController, LoadingController, Events } from '@ionic/angular';
import { SelectWeaponsPage } from '../select-weapons/select-weapons.page';
import { SelectArmorPage } from '../select-armor/select-armor.page';
import { SelectCyberwarePage } from '../select-cyberware/select-cyberware.page';
import { SelectGearPage } from '../select-gear/select-gear.page';
import { SelectProgramsPage } from '../select-programs/select-programs.page';
@Component({
  selector: 'app-gear',
  templateUrl: './gear.page.html',
  styleUrls: ['./gear.page.scss'],
})
export class GearPage implements OnInit {

    ismodal = false;
    character = GlobalService.CHARACTER;
    constructor(private router: Router, private globalService: GlobalService, private modalController: ModalController) { }

  ngOnInit() {
  }
    close() {
        this.modalController.dismiss();
    }
    removeWeapon(idx) {
        this.character.weapons.splice(idx, 1);
    }
    removeArmor(idx) {
        this.character.armor.splice(idx, 1);
    }
    removeCyberware(idx) {
        this.character.cyberware.splice(idx, 1);
    }
    removeGear(idx) {
        this.character.gear.splice(idx, 1);
    }
    removeProgram(idx) {
        this.character.programs.splice(idx, 1);
    }
    add(category) {
        switch (category) {

            case "weapons":
                this.openWeapons();
                break;
            case "armor":
                this.openArmor();
                break;
            case "cyberware":
                this.openCyberware();
                break;
            case "gear":
                this.openGear();
                break;
            case "programs":
                this.openPrograms();
                break;
        }
    }

    async openWeapons() {
            var items = this.character.statDice.filter(e => { return !e.used });
            var values = items.map(e => { return e.value });
            const modal = await this.modalController.create({
                component: SelectWeaponsPage,
                componentProps: {  }
            });
            await modal.present();
            const { data } = await modal.onDidDismiss();
        if (data) {
            this.character.weapons.push(data);
            }
    }
    async openArmor() {
        var items = this.character.statDice.filter(e => { return !e.used });
        var values = items.map(e => { return e.value });
        const modal = await this.modalController.create({
            component: SelectArmorPage,
            componentProps: {}
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            this.character.armor.push(data);
        }
    }
    async openCyberware() {
        var items = this.character.statDice.filter(e => { return !e.used });
        var values = items.map(e => { return e.value });
        const modal = await this.modalController.create({
            component: SelectCyberwarePage,
            componentProps: {}
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            this.character.cyberware.push(data);
        }
    }
    async openGear() {
        var items = this.character.statDice.filter(e => { return !e.used });
        var values = items.map(e => { return e.value });
        const modal = await this.modalController.create({
            component: SelectGearPage,
            componentProps: {}
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            this.character.gear.push(data);
        }
    }
    async openPrograms() {
        
        const modal = await this.modalController.create({
            component: SelectProgramsPage,
            componentProps: {}
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            this.character.programs.push(data);
        }
    }

}
